import React from 'react';
import ReactModal from 'react-modal';

class SignIn extends React.Component {
  constructor () {
    super();
    this.state = {
      showModal: false
    };
    
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }
  
  handleOpenModal () {
    this.setState({ showModal: true });
  }
  
  handleCloseModal () {
    this.setState({ showModal: false });
  }
  
  render () {
    return (
      <ul className="navbar-nav px-3">
        <li className="nav-item text-nowrap">
            <a className="nav-link" onClick={this.handleOpenModal} href="#">Sign in</a>
            <ReactModal 
              isOpen={this.state.showModal}
              contentLabel="Minimal Modal Example"
              overlayClassName="modal fade show"
              className="modal-dialog"
              bodyOpenClassName="modal-open">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Sign in</h5>
                  <button type="button" className="close" onClick={this.handleCloseModal} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  ...
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={this.handleCloseModal}>Close</button>
                  <button type="button" className="btn btn-primary">Sign in</button>
                </div>
              </div>
            </ReactModal>
        </li>
      </ul>
    );
  }
}

export default SignIn;



// WEBPACK FOOTER //
// ./src/components/SignIn.js